<i18n src="@/locales/modules/NoteTranslate.json"></i18n>

<template>
	<div class="note-form">
		<div class="header note-form__header flex mt-3">
			<cbs-input
				name="note-title"
				v-model="value.title"
				v-validate="'required'"
				class="header__title w-full"
				:data-vv-as="$t('Title')"
				:placeholder="`${$t('Actions.Input')} ${$t('Title').toLowerCase()}`"
			/>

			<note-color-picker
				class="header__picker mt-5"
				v-model="value.colorId"
				:data="noteColors"
				:listHeaderText="$t('SelectNoteColor')"
			/>
		</div>
		<span
			class="text-danger text-sm"
		>{{ errors.first(`note-title`) }}</span>

		<div class="note-form__date-info flex flex-wrap">
			<span
				class="mr-5 Last:mr-0 text-gray-2"
				v-if="value && value.createdDate"
			>{{ $t("CreatedDate") }}: {{ value.createdDate | dateTime(userDateTimeFormat) }}</span>
			<span
				class="mr-5 Last:mr-0 text-gray-2"
				v-if="value && value.updatedDate"
			>{{ $t("UpdatedDate") }}: {{ value.updatedDate | dateTime(userDateTimeFormat) }}</span>
		</div>

		<cbs-editor
			:placeholder="$t('WriteSomething')"
			:class="['note-form__content', {'is-focus': this.isEditorFocusing}]"
			v-model="value.content"
			@focus="() => this.isEditorFocusing = true"
			@blur="() => this.isEditorFocusing = false"
		/>

		<div class="note-form__attachs mt-3">
			<legend>{{ $t("Attachments") }}:</legend>
			<cbs-upload-ref
				multiple
				v-model="value.files"
			/>
		</div>

		<div class="note-form__actions flex justify-end items-center mt-3">
			<vs-button
				:disabled="isSubmitDisabled"
				class="w-full sm:w-1/2 md:w-1/4 font-bold"
				@click.stop="$emit('onSubmit', value)"
			>{{ $t("Actions.Save") }}</vs-button>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import NoteColorPicker from "./NoteColorPicker";
import CbsEditor from "@/components/cbs-editor/CbsEditor";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";

export default {
	name: "NoteForm",
	components: {
		CbsEditor,
		CbsUploadRef,
		NoteColorPicker
	},
	props: {
		value: {
			type: Object,
			validator: prop =>
				_.has(prop, "id") &&
				_.has(prop, "files") &&
				_.has(prop, "title") &&
				_.has(prop, "content") &&
				_.has(prop, "colorId") &&
				_.has(prop, "updatedDate") &&
				_.has(prop, "updatedDate")
		},
		isSubmitDisabled: {
			type: Boolean
		}
	},
	emits: {
		onSubmit: {}
	},
	computed: {
		noteColors() {
			return this.$constant.PICKER_COLORS || [];
		}
	},
	data() {
		return {
			selectedColorId: null,
			isEditorFocusing: false
		};
	},
	methods: {
		handleSetSelectedColor(selectedColor) {
			this.selectedColorId = selectedColor.id;
		}
	}
};
</script>

<style lang="scss" scoped>
.note-form {
	.note-form__header {
		::v-deep .header__title {
			input,
			.input-span-placeholder {
				color: var(--color-gray-2);
				padding-left: 0;
				border: none !important;
				box-shadow: none !important;
			}

			input {
				font-weight: bold;
				font-size: 16px;
			}
		}
	}

	.note-form__content {
		padding-top: 15px;
		margin-top: 15px;
		border-top: 2px solid #F4F4F4;

		::v-deep .ql-editor {
			color: var(--color-black);
			height: 50vh;

			&::before {
				left: 15px;
				font-style: normal;
			}
		}

		&.is-focus {
			::v-deep .ql-editor {
				&::before {
					transform: translateX(5px);
					transition: all 0.2s ease;
				}
			}
		}
	}
}
</style>
